import apiClient from 'ps-components/lib/apiClient';
import addAlert from 'ps-components/AlertToast/addAlert';

export const GET_JOB_DETAILS_PAGE_SELECTED_VIEW_ERROR = 'GET_JOB_DETAILS_PAGE_SELECTED_VIEW_ERROR';
export const GET_JOB_DETAILS_PAGE_SELECTED_VIEW_START = 'GET_JOB_DETAILS_PAGE_SELECTED_VIEW_START';
export const GET_JOB_DETAILS_PAGE_SELECTED_VIEW_SUCCESS = 'GET_JOB_DETAILS_PAGE_SELECTED_VIEW_SUCCESS';

export const GET_JOB_DETAILS_PAGE_VIEWS_ERROR = 'GET_JOB_DETAILS_VIEWS_ERROR';
export const GET_JOB_DETAILS_PAGE_VIEWS_START = 'GET_JOB_DETAILS_VIEWS_START';
export const GET_JOB_DETAILS_PAGE_VIEWS_SUCCESS = 'GET_JOB_DETAILS_VIEWS_SUCCESS';

export const GET_JOB_DETAILS_ERROR = 'GET_JOB_DETAILS_ERROR';
export const GET_JOB_DETAILS_START = 'GET_JOB_DETAILS_START';
export const GET_JOB_DETAILS_SUCCESS = 'GET_JOB_DETAILS_SUCCESS';

export const SET_JOB_DETAILS_SELECTED_VIEW_ERROR = 'SET_JOB_DETAILS_SELECTED_VIEW_ERROR';
export const SET_JOB_DETAILS_SELECTED_VIEW_START = 'SET_JOB_DETAILS_SELECTED_VIEW_START';
export const SET_JOB_DETAILS_SELECTED_VIEW_SUCCESS = 'SET_JOB_DETAILS_SELECTED_VIEW_SUCCESS';

const JOB_DETAILS_PAGE_NAME = 'topview';

export function getJobDetailsSelectedView(masterAccountId) {
  return async dispatch => {
    const errorMessage = 'Error retrieving selected job details view';

    try {
      dispatch({ type: GET_JOB_DETAILS_PAGE_SELECTED_VIEW_START });
      const result = await apiClient.apiGet(`/cms/api/accounts/${masterAccountId}/views/last-viewed`, {
        params: {
          contextName: JOB_DETAILS_PAGE_NAME
        }
      });

      if (result.status < 300) {
        dispatch({ type: GET_JOB_DETAILS_PAGE_SELECTED_VIEW_SUCCESS, selectedViewPk: result.data?.data?.view_pk });
        return result.data?.data?.view_pk;
      } else {
        throw Error(errorMessage);
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log('Catch Error: Get Job Details Selected View: ', error);
      dispatch({ type: GET_JOB_DETAILS_PAGE_SELECTED_VIEW_ERROR });
    }
  };
}

export function getJobDetailsViews(masterAccountId) {
  return async dispatch => {
    const errorMessage = 'Error retrieving job details views';

    try {
      dispatch({ type: GET_JOB_DETAILS_PAGE_VIEWS_START });
      const result = await apiClient.apiGet(`/cms/api/accounts/${masterAccountId}/views`, {
        params: {
          contextName: JOB_DETAILS_PAGE_NAME,
          portAll: true,
          isFacet: false
        }
      });

      if (result.status < 300) {
        dispatch({
          type: GET_JOB_DETAILS_PAGE_VIEWS_SUCCESS,
          views: result.data?.data?.views,
          defaultViewId: result?.data?.data?.defaultViewId
        });
      } else {
        throw Error(errorMessage);
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log('Catch Error: Get Job Details Views: ', error);
      dispatch({ type: GET_JOB_DETAILS_PAGE_VIEWS_ERROR });
    }
  };
}

export function getJobDetails(masterAccountId, { jobCode, jobCodeKey, viewPk }) {
  return async dispatch => {
    const errorMessage = 'Error getting job details data';

    try {
      dispatch({ type: GET_JOB_DETAILS_START });

      const params = {
        jobCode,
        jobCodeKey,
        viewPk
      };

      const result = await apiClient.apiPost(`/cms/api/accounts/${masterAccountId}/job-details`, params);

      dispatch({
        type: GET_JOB_DETAILS_SUCCESS,
        jobDetailsData: result?.data?.data
      });
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log('Catch Error: Get Job Details: ', error);
      dispatch({
        type: GET_JOB_DETAILS_ERROR
      });
    }
  };
}

export function setJobDetailsSelectedView(masterAccountId, viewPk) {
  return async dispatch => {
    const errorMessage = 'Error setting selected job details view';

    try {
      dispatch({ type: SET_JOB_DETAILS_SELECTED_VIEW_START });

      const result = await apiClient.apiPost(`/cms/api/accounts/${masterAccountId}/views/last-viewed`, {
        contextName: JOB_DETAILS_PAGE_NAME,
        viewId: viewPk
      });

      if (result.status < 300) {
        dispatch({ type: SET_JOB_DETAILS_SELECTED_VIEW_SUCCESS, selectedViewPk: viewPk });
      } else {
        throw Error(errorMessage);
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.log('Catch Error, Set Job Details Selected View: ', error);
      dispatch({ type: SET_JOB_DETAILS_SELECTED_VIEW_ERROR });
    }
  };
}
